import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import { Skeleton } from '@node-space/storybook-components/dist/SkeletonLoader'
import { Box } from '@node-space/ui-components'

export const SidePanelSkeletonLoader = () => {
  return (
    <>
      <Skeleton variant="title" className="w-52" />
      <Box>
        {[...Array(8)]?.map((row, index) => (
          <Box key={uuidv4()} flex paddingY={12} justify="between">
            <Skeleton className={`w-${index % 2 ? 24 : 20}`} />
            <Skeleton className={`w-${index % 2 ? 40 : 32}`} />
          </Box>
        ))}
      </Box>
    </>
  )
}
